import type { VFC } from 'react';
import Upload from 'antd/lib/upload/Upload';
import { Button } from 'antd';
import { Icon } from '@/components/icon';
import { useUploadHardwareList } from 'api/hooks';

export const UploadButton: VFC<{ onSuccess: () => void }> = ({ onSuccess }) => {
  const { mutate: uploadCsv, isLoading: isUploading } = useUploadHardwareList(onSuccess);

  return (
    <Upload
      key="upload-hardware-list-csv"
      accept=".csv"
      beforeUpload={() => false}
      data-cy="upload-hardware-list-csv-cta"
      maxCount={1}
      multiple={false}
      name="file"
      showUploadList={false}
      onChange={item => uploadCsv(item.fileList[0])}
    >
      <Button icon={isUploading ? <Icon iconString="spinner" /> : <Icon iconString="upload" />}>
        Update Hardware List
      </Button>
    </Upload>
  );
};
